import './Rules.css';
import { Helmet } from "react-helmet-async";

export default function Rules() {
    return (
        <div id="rules" lang="pl">
            <Helmet>
                <title>Regulamin | Lumestore</title>
                <meta name="description" content="Regulamin sklepu internetowego Lumestore."/>
                <link rel="canonical" href="https://lumestore.pl/regulamin"/>
                <meta property="og:type" content="article"/>
                <meta property="og:title" content="Regulamin | Lumestore"/>
                <meta property="og:description" content="Regulamin sklepu internetowego Lumestore."/>
                <meta property="og:url" content="https://lumestore.pl/regulamin"/>
            </Helmet>

            <section>
                <h2>1. POSTANOWIENIA OGÓLNE</h2>
                <ul>
                    <li>Sklep internetowy: Lume Store, działający pod adresem: lumestore.pl, prowadzony jest przez: LUMESTORE PROSTA SPÓŁKA AKCYJNA,
                        z siedzibą w/przy: ul. Pograniczna 13, 32-087 Garlica Murowana, NIP: 5130301837
                    </li>
                    <li>Niniejszy Regulamin Sklepu internetowego określa zasady dokonywania zakupów w sklepie internetowym:
                        Lume Store, a w szczególności zasady i tryb zawierania umów sprzedaży na odległość za pośrednictwem
                        Sklepu, jak również tryb postępowania reklamacyjnego oraz tryb odstąpienia od umowy przez
                        Konsumenta.
                    </li>
                    <li>W zakresie Usług świadczonych drogą elektroniczną niniejszy Regulamin jest regulaminem, o którym
                        mowa w art. 9 ustawy o świadczeniu usług drogą elektroniczną z dnia 18 lipca 2002 r. (tj. Dz.U. z
                        2024 r. poz. 1513, ze zm.).
                    </li>
                    <li>Regulamin skierowany jest do wszystkich Klientów Sklepu. Wszyscy Klienci są obowiązani zapoznać się
                        z postanowieniami Regulaminu, przed dokonaniem zakupu.
                    </li>
                    <li>Każdy Klient zobowiązany jest przestrzegać postanowienia Regulaminu. Sprzedaż odbywa się na
                        podstawie wersji Regulaminu, obowiązującej w momencie złożenia zamówienia.
                    </li>
                    <li>Każdy Klient ma możliwość zapoznać się z Regulaminem w każdym czasie, klikając na stronie
                        internetowej Sklepu: lumestore.pl w hiperlink: „Regulamin Sklepu". Regulamin można w każdym czasie
                        pobrać i wydrukować.
                    </li>
                    <li>Wszystkie informacje zawarte na stronie internetowej Sklepu: lumestore.pl, odnoszące się do
                        produktów (łącznie z cenami), nie stanowią oferty w rozumieniu art. 66 ustawy z dnia 23 kwietnia
                        1964 r. Kodeks Cywilny (t.j. Dz.U. z 2024 r. poz. 1061, ze zm.), lecz zaproszenie do zawarcia umowy,
                        w myśl art. 71 ustawy z dnia 23 kwietnia 1964 r. Kodeks Cywilny (tj. Dz.U. z 2024 r. poz. 1061, ze
                        zm.). Klient wysyłając Formularz Zamówienia składa ofertę kupna i dostawy wskazanego Towaru, za cenę
                        i na warunkach określonych w opisie.
                    </li>
                </ul>
            </section>

            <section>
                <h2>2. DEFINICJE</h2>
                <ul>
                    <li><strong>Regulamin</strong> – niniejszy zbiór regulacji organizujących zasady korzystania z Usług
                        Sklepu przez Klientów.
                    </li>
                    <li><strong>Konsument</strong> – osoba fizyczna zawierająca Umowę za pośrednictwem Sklepu, niezwiązaną
                        bezpośrednio z jej działalnością gospodarczą lub zawodową.
                    </li>
                    <li><strong>Przedsiębiorca na prawach Konsumenta</strong> – osoba fizyczna zawierająca Umowę
                        cywilnoprawną za pośrednictwem Sklepu, bezpośrednio związaną z jej działalnością gospodarczą, gdy z
                        treści tej Umowy wynika, że nie posiada ona dla tej osoby charakteru zawodowego wynikającego w
                        szczególności z przedmiotu wykonywanej przez nią działalności gospodarczej, udostępnionego na
                        podstawie przepisów o Centralnej Ewidencji i Informacji o Działalności Gospodarczej. Dla celów
                        niniejszego Regulaminu przyjmuje się, że w razie braku rozróżnienia wskazanych dwóch grup podmiotów,
                        Regulamin odnosi się zarówno do Konsumentów, jak też Przedsiębiorców na prawach Konsumenta.
                    </li>
                    <li><strong>Klient</strong> – osoba fizyczna (w tym Konsument), która ukończyła co najmniej 13 lat (pod
                        warunkiem, że uzyskała zgodę przedstawiciela ustawowego), osoba prawna oraz jednostka organizacyjna
                        niebędąca osobą prawną, której przepisy szczególne przyznają zdolność prawną, która korzysta z Usług
                        świadczonych przez Sklep.
                    </li>
                    <li><strong>Formularz Zamówienia</strong> – Usługa dostępna na stronie internetowej Sklepu, za pomocą
                        której Klient może dokonać zakupu, w szczególności poprzez dodanie Towarów do Koszyka oraz
                        określenie niektórych warunków Umowy Sprzedaży m.in. sposobu dostawy i płatności.
                    </li>
                    <li><strong>Koszyk</strong> – element Sklepu, w którym widoczne są wybrane przez Klienta Towary oraz w
                        którym Klient ma możliwość ustalenia i modyfikacji danych Zamówienia, w tym ilości nabywanych
                        Produktów.
                    </li>
                    <li><strong>Sklep</strong> – internetowa platforma handlowa, należąca do Sprzedawcy, dostępna pod
                        domeną: lumestore.pl, za pośrednictwem której Klient może zakupić od Sprzedawcy Towary.
                    </li>
                    <li><strong>Sprzedawca</strong> – LUMESTORE PROSTA SPÓŁKA AKCYJNA, z siedzibą przy: ul. Pograniczna 13, 32-087 Garlica
                        Murowana, NIP: 5130301837, który prowadząc działalność zarobkową lub zawodową proponuje sprzedaż za
                        pomocą swojej strony internetowej.
                    </li>
                    <li><strong>Towar</strong> – rzecz ruchoma, będąca przedmiotem obrotu pomiędzy Sklepem i Klientem,
                        którego warunki sprzedaży określa Formularz Zamówienia.
                    </li>
                    <li><strong>Towar z elementami cyfrowymi</strong> – towar zawierający treść cyfrową lub usługę cyfrową
                        lub z nimi połączony w taki sposób, że brak treści cyfrowej lub usługi cyfrowej uniemożliwiłby jego
                        prawidłowe funkcjonowanie.
                    </li>
                    <li><strong>Produkt</strong> – każdy towar lub usługa, w tym nieruchomości, usługi cyfrowe i treści
                        cyfrowe, a także prawa i obowiązki.
                    </li>
                    <li><strong>Środowisko cyfrowe</strong> – sprzęt komputerowy, oprogramowanie i połączenia sieciowe,
                        wykorzystywane przez Konsumenta w celu uzyskania dostępu do treści cyfrowej lub usługi cyfrowej lub
                        w celu korzystania z nich.
                    </li>
                    <li><strong>Integracja</strong> – połączenie treści cyfrowej lub usługi cyfrowej z elementami środowiska
                        cyfrowego Konsumenta i włączenie ich do tych elementów w celu zapewnienia zgodności z Umową o
                        dostarczanie treści cyfrowej lub usługi cyfrowej.
                    </li>
                    <li><strong>Kompatybilność</strong> – współdziałanie treści cyfrowej, usługi cyfrowej lub towaru ze
                        sprzętem komputerowym lub oprogramowaniem, które są zazwyczaj używane do korzystania z treści
                        cyfrowej, usługi cyfrowej lub towaru tego samego rodzaju, bez konieczności ich przekształcania.
                    </li>
                    <li><strong>Funkcjonalność</strong> – zdolność treści cyfrowej, usługi cyfrowej lub towaru do pełnienia
                        swoich funkcji z uwzględnieniem ich przeznaczenia.
                    </li>
                    <li><strong>Interoperacyjność</strong> – zdolność treści cyfrowej, usługi cyfrowej lub towaru do
                        współdziałania ze sprzętem komputerowym lub oprogramowaniem innymi niż te zazwyczaj używane do
                        korzystania z treści cyfrowej, usługi cyfrowej lub towaru tego samego rodzaju.
                    </li>
                    <li><strong>Internetowa platforma handlowa</strong> – usługa korzystająca z oprogramowania, w tym ze
                        strony internetowej, z części strony internetowej lub aplikacji, obsługiwanego przez przedsiębiorcę
                        lub w jego imieniu, w ramach której umożliwia się Konsumentom zawieranie z innymi przedsiębiorcami
                        umów na odległość lub osobom fizycznym, niebędącym przedsiębiorcami, zawieranie umów na odległość z
                        innymi osobami fizycznymi, niebędącymi przedsiębiorcami.
                    </li>
                    <li><strong>Dostawca internetowej platformy handlowej</strong> – przedsiębiorca, który obsługuje
                        internetową platformę handlową, dostarcza podmiotom internetową platformę handlową lub umożliwia
                        korzystanie z tej platformy.
                    </li>
                    <li><strong>Umowa</strong> – umowa sprzedaży Towarów na odległość, zawarta przez Klienta za
                        pośrednictwem Sklepu, zwykle przez Formularz Zamówienia.
                    </li>
                </ul>
            </section>

            <section>
                <h2>3. PRZYJMOWANIE I REALIZACJA ZAMÓWIEŃ</h2>
                <ul>
                    <li>Warunkiem korzystania ze Sklepu jest zapoznanie się z niniejszym Regulaminem i jego akceptacja.
                        Składając zamówienie Klient akceptuje treść Regulaminu.
                    </li>
                    <li>
                        Główne parametry, decydujące o plasowaniu ofert, przedstawionych Konsumentowi w wyniku wyszukiwania,
                        przedstawiane również w bezpośrednim powiązaniu z daną ofertą, w widoczny sposób, są następujące:
                        <ul>
                            <li>Produkty w sklepie internetowym prezentowane są według domyślnych ustawień systemu, w
                                szczególności: daty dodania produktu, kategorii, ceny lub popularności (najczęściej
                                kupowane). Klient ma możliwość zmiany kolejności wyświetlania poprzez skorzystanie z
                                dostępnych filtrów i opcji sortowania (np. od najniższej do najwyższej ceny, od
                                najnowszych).
                            </li>
                            <li>Sklep może dodatkowo wyróżniać określone produkty poprzez umieszczenie ich na początku
                                listy, oznaczenie jako „promocja" lub „bestseller". Decyzja o wyróżnieniu ma charakter
                                marketingowy i nie wpływa na obowiązujące ceny produktów.
                            </li>
                        </ul>
                    </li>
                    <li>Sklep oznacza oferty sponsorowane oraz płatne reklamy. Informacje te są przedstawiane w bezpośrednim
                        powiązaniu z danym wynikiem wyszukiwania, w widoczny sposób, który wyróżnia się z ogólnego
                        interfejsu.
                    </li>
                    <li>Podana w zamówieniu cena stanowi całkowitą wartość, jaką Klient zobowiązany jest zapłacić,
                        zawierającą należny podatek (cena brutto). Koszt dostawy nie jest wliczony w cenę, gdyż zależy od
                        wybranego przez Klienta sposobu dostawy Produktu.
                    </li>
                    <li>Jeżeli Konsument zobowiązany będzie do płatności wykraczającej poza uzgodnioną cenę, opisaną w
                        ustępie poprzednim, Sklep niezwłocznie poinformuje Konsumenta o tym fakcie, wyjaśniając przyczynę
                        różnicy ceny. Obciążenie Konsumenta dodatkowymi kosztami nastąpi wyłącznie po uzyskaniu wyraźnej
                        zgody Konsumenta.
                    </li>
                    <li>Sprzedawca zastrzega sobie prawo zmiany cen, znajdujących się w Sklepie, wprowadzania nowych
                        Produktów do sprzedaży, przeprowadzania i odwoływania akcji promocyjnych, bądź wprowadzania w nich
                        zmian, zgodnie z obowiązującymi przepisami prawa.
                    </li>
                    <li>W razie wprowadzenia promocji, Sklep informuje Klientów o najniższej cenie Produktu z ostatnich 30
                        dni. Jeśli Produkt jest w sprzedaży krócej niż 30 dni, cena przed promocją to najniższa cena od
                        momentu wprowadzenia Produktu do Sklepu. Informacje te są przedstawiane obok ceny promocyjnej
                        Produktu.
                    </li>
                    <li>Zamówienia od Klientów są przyjmowane za pomocą wysłanego Formularza Zamówień, dokonanego za
                        pośrednictwem strony: lumestore.pl, 7 dni w tygodniu, 24 godziny na dobę.
                    </li>
                    <li>Zamówienie Produktu realizuje się poprzez wybranie Towaru, którymi Klient jest zainteresowany,
                        kliknięcie przycisku „DODAJ DO KOSZYKA", znajdującego się przy opisie Produktu, a następnie, z
                        poziomu „KOSZYK", znajdującego się w zakładce Sklepu, wypełnienie Formularza Zamówienia, w tym
                        wyboru formy dostawy i zapłaty bądź wyboru opcji zapłaty przy odbiorze, jeśli takowa jest dostępna
                        dla wybranego Produktu, a następnie kliknięcie potwierdzenia zakupu.
                    </li>
                    <li>Przedsiębiorcy na prawach Konsumenta powinni zaznaczyć, już w chwili składania zamówienia Produktów,
                        że zakup nie ma dla nich charakteru zawodowego.
                    </li>
                    <li>Po złożeniu zamówienia Klient dostaje potwierdzenie złożonego zamówienia na swój adres e-mail,
                        podany w Formularzu Zamówienia.
                    </li>
                    <li>Po otrzymaniu przez Klienta potwierdzenia przyjęcia oferty, rozpoczyna się proces realizacji
                        zamówienia przez Sprzedawcę, przy czym:
                        <ul>
                            <li>a) w przypadku złożenia zamówienia płatnego przy odbiorze – rozpoczyna się maksymalnie
                                następnego dnia roboczego, po jego potwierdzeniu przez Sprzedawcę.
                            </li>
                            <li>b) w przypadku złożenia zamówienia płatnego przelewem tradycyjnym – rozpoczyna się po
                                zaksięgowaniu wpłaty za złożone zamówienie, na koncie bankowym Sklepu.
                            </li>
                        </ul>
                    </li>
                    <li>Zamówienia złożone w Sklepie są realizowane w godzinach pracy Sklepu (w dni robocze, od poniedziałku
                        do piątku, w godzinach od 9:00 do 14:00). Zamówienia złożone w dni robocze po godzinie 14:00, w
                        soboty, niedziele lub święta, będą rozpatrywane następnego dnia roboczego.
                    </li>
                    <li>Klient otrzyma wiadomość o przyjęciu zamówienia do realizacji, co jest rozumiane jako oświadczenie
                        Sprzedawcy o przyjęciu oferty. Z chwilą jego otrzymania przez Klienta, zostaje zawarta Umowa
                        sprzedaży.
                    </li>
                    <li>Do każdego zamówienia wystawiany jest paragon VAT. Na życzenie Klienta zostanie również wystawiona i
                        wysłana Klientowi faktura VAT (art. 106b ust. 3 ustawy z dnia 11 marca 2004 r. o podatku od towarów
                        i usług, t.j. Dz.U. z 2023 r. poz. 1570, ze zm.).
                    </li>
                    <li>Dostępnymi środkami porozumiewania się Klienta ze Sklepem są:
                        <ul>
                            <li>a) E-mail – kontakt@lumestore.pl</li>
                            <li>b) Telefon tymczasowy – 668366490</li>
                            <li>c) Adres w celu realizacji odstąpienia od Umowy: ul. Pograniczna 13, 32-087 Garlica
                                Murowana
                            </li>
                        </ul>
                    </li>
                    <li>Sprzedawca nie weryfikuje autentyczności recenzji Klientów na temat zakupionych w Sklepie
                        Produktów.
                    </li>
                    <li>Wszelkie opinie lub rekomendacje, które zostały sporządzone na płatne zamówienie Sprzedawcy, zostaną
                        oznaczone w Sklepie jako opinie lub rekomendacje sponsorowane.
                    </li>
                </ul>
            </section>

            <section>
                <h2>4. DOSTAWA I KOSZTY TRANSPORTU</h2>
                <ul>
                    <li>Realizacja wysyłki zamówienia w Sklepie odbywa się za pośrednictwem:
                        <ul>
                            <li>paczkomatu</li>
                            <li>kuriera</li>
                        </ul>
                    </li>
                    <li>Zamówienia składane w Sklepie są realizowane wyłącznie w dni robocze. Zamówienia składane w soboty,
                        niedziele i święta będą zrealizowane najbliższego dnia roboczego.
                    </li>
                    <li>Czas oczekiwania na przesyłkę wynosi zwykle 2 dni robocze. Na czas oczekiwania składa się czas
                        realizacji zamówienia, a więc skompletowanie Produktów do zamówienia oraz przewidywany czas dostawy,
                        który wynosi od 24 godzin w przypadku Polski.
                    </li>
                    <li>Sprzedawca nie odpowiada za opóźnienia wynikające z winy przewoźnika.</li>
                    <li>Podczas odbioru przesyłki dostarczonej przez kuriera, Klient powinien w jego obecności dokładnie
                        sprawdzić zawartość i kompletność przesyłki, stan opakowania zewnętrznego oraz stan zamówionego
                        Produktu. W przypadku uszkodzenia przesyłki Klient powinien sporządzić wraz z kurierem protokół
                        szkody, w dwóch jednobrzmiących egzemplarzach podpisanych przez Klienta i kuriera.
                    </li>
                    <li>W przypadku nieodebrania przez Klienta przesyłki opłaconej z góry i jej zwrotu do Sprzedawcy,
                        Umowę uznaje się za niewykonaną z przyczyn leżących po stronie Klienta. Sprzedawca dokona zwrotu
                        uiszczonej przez Klienta kwoty w terminie do 14 dni od dnia otrzymania zwróconej przesyłki,
                        pomniejszając ją o koszty dostawy oraz ewentualne koszty zwrotu przesyłki do Sprzedawcy.
                    </li>
                </ul>
            </section>

            <section>
                <h2>5. REALIZACJA PŁATNOŚCI</h2>
                <ul>
                    <li>W ramach funkcjonowania Sklepu możliwe są następujące sposoby płatności:
                        <ul>
                            <li>1) przelewem,</li>
                            <li>2) Blik, Tpay, Przelewy24.</li>
                        </ul>
                    </li>
                    <li>Szczegółowe zasady i warunki dokonywania płatności za pośrednictwem banków lub innych dostępnych
                        serwisów określają właściwe regulaminy odpowiednich banków i serwisów.
                    </li>
                    <li>Klient, który wybrał opcję płatności przelewem, jest zobowiązany do uiszczenia opłaty za złożone
                        zamówienie w terminie do pięciu (5) dni roboczych od daty złożenia zamówienia. W przeciwnym wypadku
                        oferta Sprzedawcy nie jest wiążąca i zamówienie zostaje usunięte z systemu. W tytule płatności
                        wystarczy podać tylko numer składanego zamówienia. Istnieje możliwość przedłużenia terminu zapłaty,
                        przy uprzednim poinformowaniu o tym fakcie obsługi Sklepu: kontakt@lumestore.pl (e-mail), ul. Pograniczna 13, 32-087 Garlica Murowana (adres).
                    </li>
                </ul>
            </section>

            <section>
                <h2>6. REKLAMACJA</h2>
                <ul>
                    <li>Sprzedawca ponosi odpowiedzialność z tytułu niezgodności Produktu z Umową. Do umów zobowiązujących
                        do przeniesienia własności Towaru na Konsumenta, w tym w szczególności umów sprzedaży, umów dostawy
                        oraz umów o dzieło będące Towarem, nie stosuje się przepisów ustawy z dnia 23 kwietnia 1964 r.
                        Kodeks Cywilny (t.j. Dz.U. z 2023 r. poz. 1610, ze zm.), dotyczących rękojmi za wady.
                    </li>
                    <li>Sprzedawca ponosi odpowiedzialność za brak zgodności z Umową Produktu, który to brak istnieje w
                        chwili jego dostarczenia i jest ujawniony w ciągu dwóch (2) lat od tej chwili, chyba że termin
                        przydatności Produktu do użycia, określony przez Sprzedawcę, jego poprzedników prawnych lub osoby
                        działające w ich imieniu, jest dłuższy. Domniemywa się, że brak zgodności Produktu z Umową, który
                        ujawnił się przed upływem dwóch (2) lat od chwili dostarczenia Produktu, istniał w chwili jego
                        dostarczenia, o ile nie zostanie udowodnione inaczej lub domniemania tego nie można pogodzić ze
                        specyfiką Produktu lub charakterem braku zgodności Produktu z Umową.
                    </li>
                    <li>Jeżeli Produkt jest niezgodny z Umową, Konsument może żądać jego naprawy lub wymiany. Sprzedawca
                        może dokonać wymiany, gdy Konsument żąda naprawy, lub Sprzedawca może dokonać naprawy, gdy Konsument
                        żąda wymiany, jeżeli doprowadzenie do zgodności Produktu z Umową w sposób wybrany przez Konsumenta
                        jest niemożliwe albo wymagałoby nadmiernych kosztów dla Sprzedawcy. Jeżeli naprawa i wymiana są
                        niemożliwe lub wymagałyby nadmiernych kosztów dla Sprzedawcy, może on odmówić doprowadzenia Produktu
                        do zgodności z Umową.
                    </li>
                    <li>Sprzedawca dokonuje naprawy lub wymiany w rozsądnym czasie od chwili, w której Konsument
                        poinformował go o braku zgodności z Umową, i bez nadmiernych niedogodności dla Konsumenta,
                        uwzględniając specyfikę Produktu oraz cel, w jakim Konsument go nabył. Koszty naprawy lub wymiany, w
                        tym w szczególności koszty opłat pocztowych, przewozu, robocizny i materiałów, ponosi Sprzedawca. W
                        tym celu Konsument udostępni Sprzedawcy Produkt podlegający naprawie lub wymianie. Sprzedawca
                        odbiera od Konsumenta Produkt na swój koszt. Jeżeli Produkt został zamontowany przed ujawnieniem się
                        braku zgodności Produktu z Umową, Sprzedawca demontuje Produkt oraz montuje go ponownie po dokonaniu
                        naprawy lub wymiany albo zleca wykonanie tych czynności na swój koszt.
                    </li>
                    <li>Jeżeli Produkt jest niezgodny z Umową, Konsument może złożyć oświadczenie o obniżeniu ceny albo
                        odstąpieniu od Umowy, gdy:
                        <ul>
                            <li>a) Sprzedawca odmówił doprowadzenia Produktu do zgodności z Umową,</li>
                            <li>b) Sprzedawca nie doprowadził Produktu do zgodności z Umową,</li>
                            <li>c) brak zgodności Produktu z Umową występuje nadal, mimo że Sprzedawca próbował doprowadzić
                                Produkt do zgodności z Umową,
                            </li>
                            <li>d) brak zgodności Produktu z Umową jest na tyle istotny, że uzasadnia obniżenie ceny albo
                                odstąpienie od Umowy, bez uprzedniego żądania jego naprawy albo wymiany,
                            </li>
                            <li>e) z oświadczenia Sprzedawcy lub okoliczności wyraźnie wynika, że nie doprowadzi on Produktu
                                do zgodności z Umową w rozsądnym czasie lub bez nadmiernych niedogodności dla Konsumenta.
                            </li>
                        </ul>
                    </li>
                    <li>Obniżona cena musi pozostawać w takiej proporcji do ceny wynikającej z Umowy, w jakiej wartość
                        Produktu niezgodnego z Umową pozostaje do wartości Produktu zgodnego z Umową. Sprzedawca zwraca
                        Konsumentowi kwoty należne wskutek skorzystania z prawa obniżenia ceny niezwłocznie, nie później niż
                        w terminie czternastu (14) dni od dnia otrzymania oświadczenia Konsumenta o obniżeniu ceny.
                    </li>
                    <li>Konsument nie może odstąpić od Umowy, jeżeli brak zgodności Produktu z Umową jest nieistotny.
                        Domniemywa się, że brak zgodności Produktu z Umową jest istotny.
                    </li>
                    <li>W razie odstąpienia od Umowy Konsument niezwłocznie zwraca Produkt Sprzedawcy na jego koszt.
                        Sprzedawca zwraca Konsumentowi cenę niezwłocznie, nie później niż w terminie czternastu (14) dni od
                        dnia otrzymania Produktu lub dowodu jego odesłania, przy użyciu takiego samego sposobu zapłaty,
                        jakim posłużył się Konsument, chyba że Konsument wyraźnie zgodził się na inny sposób zwrotu, który
                        nie wiąże się dla niego z żadnymi kosztami.
                    </li>
                    <li>Reklamacje dotyczące Produktów mogą być zgłaszane:
                        <ul>
                            <li>a) na piśmie, na adres siedziby Sprzedawcy: ul. Pograniczna 13, 32-087 Garlica Murowana,
                            </li>
                            <li>b) pocztą elektroniczną, na adres e-mail: kontakt@lumestore.pl.</li>
                        </ul>
                    </li>
                    <li>Reklamacja powinna zawierać:
                        <ul>
                            <li>a) dane osoby składającej reklamację (imię i nazwisko, adres korespondencyjny, adres e-mail
                                i numer telefonu kontaktowego),
                            </li>
                            <li>b) wskazanie przyczyny reklamacji oraz treści żądania,</li>
                            <li>c) numer Zamówienia, widniejący w potwierdzeniu przyjęcia Zamówienia,</li>
                            <li>d) oryginał lub kopia dowodu zakupu (np. paragonu lub faktury) może ułatwić złożenie
                                reklamacji, ale nie jest niezbędny do jej złożenia.
                            </li>
                        </ul>
                    </li>
                    <li>
                        Reklamacje są rozpatrywane przez Sprzedawcę w terminie 14 (czternastu) dni kalendarzowych od dnia ich otrzymania. Odpowiedź na reklamację zostanie udzielona Konsumentowi w formie korespondencji elektronicznej na adres e-mail wskazany w zgłoszeniu lub w inny sposób uzgodniony z Konsumentem.
                    </li>
                </ul>
            </section>

            <section>
                <h2>7. PRAWO ODSTĄPIENIA</h2>
                <ul>
                    <li>Zgodnie z ustawą z dnia 30 maja 2014 r. o prawach konsumenta (tj. Dz.U. z 2020 r. poz. 287, ze zm.),
                        Konsument może odstąpić od Umowy dotyczącej Produktów zakupionych w Sklepie, bez podania przyczyny,
                        składając stosowne oświadczenie na piśmie, w terminie czternastu (14) dni, licząc od dnia wydania
                        Towaru (tj. od dnia odebrania Towaru przez Konsumenta). Termin ten uważa się za zachowany, jeśli
                        Konsument wyśle oświadczenie przed jego upływem.
                    </li>
                    <li>Konsument może odstąpić od Umowy, składając Sprzedawcy oświadczenie o odstąpieniu od Umowy. Wzór
                        oświadczenia stanowi załącznik nr 1 do niniejszego Regulaminu.
                    </li>
                    <li>Oświadczenie o odstąpieniu od Umowy należy wysłać na adres: ul. Pograniczna 13, 32-087 Garlica
                        Murowana.
                    </li>
                    <li>Konsument zwróci Sprzedawcy Towar w terminie czternastu (14) dni od dnia, w którym odstąpił od
                        Umowy. Do zachowania terminu wystarczy odesłanie Towaru przed jego upływem.
                    </li>
                    <li>Konsument ponosi tylko bezpośrednie koszty zwrotu Towaru.</li>
                    <li>Zwrotu Towaru należy dokonać na adres Sprzedawcy: ul. Pograniczna 13, 32-087 Garlica Murowana.</li>
                    <li>Sprzedawca, w terminie czternastu (14) dni od dnia otrzymania oświadczenia o odstąpieniu od Umowy,
                        zwróci Konsumentowi wszystkie dokonane przez niego płatności, w tym koszt dostarczenia Towaru, przy
                        czym zwrot płatności nie nastąpi do chwili otrzymania Towaru z powrotem lub dostarczenia przez
                        Konsumenta dowodu jego odesłania.
                    </li>
                    <li>Jeżeli Konsument wybrał sposób dostarczenia Towaru inny niż najtańszy sposób dostarczenia, oferowany
                        przez Sprzedawcę, Sprzedawca nie jest zobowiązany do zwrotu Konsumentowi poniesionych przez niego
                        dodatkowych kosztów.
                    </li>
                    <li>Sprzedawca dokona zwrotu płatności przy użyciu takiego samego sposobu zapłaty, jakiego użył
                        Konsument.
                    </li>
                    <li>Konsument ponosi odpowiedzialność za zmniejszenie wartości Produktu, będące wynikiem korzystania z
                        niego w sposób wykraczający poza konieczny do stwierdzenia charakteru, cech i funkcjonowania
                        Produktu.
                    </li>
                    <li>Prawo odstąpienia od Umowy Sprzedaży nie przysługuje Konsumentowi w odniesieniu do Umowy:
                        <ul>
                            <li>a) w której przedmiotem świadczenia jest Towar nieprefabrykowany, wyprodukowany według
                                specyfikacji Konsumenta lub służący zaspokojeniu jego zindywidualizowanych potrzeb,
                            </li>
                            <li>b) w której przedmiotem świadczenia jest Towar ulegający szybkiemu zepsuciu lub mający
                                krótki termin przydatności do użycia,
                            </li>
                            <li>c) w której przedmiotem świadczenia są napoje alkoholowe, których cena została uzgodniona
                                przy zawarciu Umowy, a których dostarczenie może nastąpić dopiero po upływie 30 dni i
                                których wartość zależy od wahań na rynku, nad którymi Sprzedawca nie ma kontroli,
                            </li>
                            <li>d) w której przedmiotem świadczenia jest Towar dostarczany w zapieczętowanym opakowaniu,
                                którego po otwarciu opakowania nie można zwrócić ze względu na ochronę zdrowia lub ze
                                względów higienicznych, jeżeli opakowanie zostało otwarte po dostarczeniu,
                            </li>
                            <li>e) w której przedmiotem świadczenia są Towary, które po dostarczeniu, ze względu na swój
                                charakter, zostają nierozłącznie połączone z innymi towarami,
                            </li>
                            <li>f) w której przedmiotem świadczenia są nagrania dźwiękowe lub wizualne albo programy
                                komputerowe, dostarczane w zapieczętowanym opakowaniu, jeżeli opakowanie zostało otwarte po
                                dostarczeniu,
                            </li>
                            <li>g) o dostarczanie dzienników, periodyków lub czasopism, z wyjątkiem umowy o prenumeratę,
                            </li>
                            <li>h) w której cena lub wynagrodzenie zależy od wahań na rynku finansowym, nad którymi
                                Sprzedawca nie sprawuje kontroli, i które mogą wystąpić przed upływem terminu do odstąpienia
                                od Umowy,
                            </li>
                            <li>i) o dostarczanie Towarów z elementami cyfrowymi, usług cyfrowych lub treści cyfrowych,
                                niedostarczanych na nośniku materialnym, za które Konsument jest zobowiązany do zapłaty
                                ceny, jeżeli Sprzedawca rozpoczął świadczenie za wyraźną i uprzednią zgodą Konsumenta, który
                                został poinformowany przed rozpoczęciem świadczenia, że po spełnieniu świadczenia przez
                                Sprzedawcę utraci prawo do odstąpienia od Umowy, i przyjął to do wiadomości, a Sprzedawca
                                przekazał mu potwierdzenie,
                            </li>
                            <li>j) zawartej w drodze aukcji publicznej,</li>
                            <li>k) o świadczenie usług w zakresie zakwaterowania, innych niż do celów mieszkalnych, przewozu
                                towarów, najmu samochodów, gastronomii, usług związanych z wypoczynkiem, wydarzeniami
                                rozrywkowymi, sportowymi lub kulturalnymi, jeżeli w Umowie oznaczono dzień lub okres
                                świadczenia usługi,
                            </li>
                            <li>l) w której Konsument wyraźnie żądał, aby Sprzedawca do niego przyjechał w celu dokonania
                                pilnej naprawy lub konserwacji; jeżeli Sprzedawca świadczy dodatkowo inne usługi niż te,
                                których wykonania Konsument żądał, lub dostarcza towary inne niż części zamienne, niezbędne
                                do wykonania naprawy lub konserwacji – prawo odstąpienia od Umowy przysługuje Konsumentowi w
                                odniesieniu do dodatkowych Usług lub Towarów,
                            </li>
                            <li>m) o świadczenie usług, za które Konsument jest zobowiązany do zapłaty ceny, w przypadku, w
                                którym Konsument wyraźnie zażądał od Sprzedawcy, aby przyjechał do niego w celu dokonania
                                naprawy, a usługa została już w pełni wykonana za wyraźną i uprzednią zgodą Konsumenta.
                            </li>
                        </ul>
                    </li>
                    <li>Prawo odstąpienia od umowy, o którym mowa powyżej, przysługuje wyłącznie Klientom będącym
                        Konsumentami lub Przedsiębiorcami na prawach Konsumenta w rozumieniu art. 38a ustawy z dnia 30 maja
                        2014 r. o prawach konsumenta. Klient będący przedsiębiorcą, który zawiera Umowę bezpośrednio
                        związaną z prowadzoną działalnością gospodarczą lub zawodową (B2B), nie jest uprawniony do
                        odstąpienia od Umowy zawartej na odległość ani do korzystania z uprawnień przewidzianych dla
                        Konsumentów.
                    </li>
                </ul>
            </section>

            <section>
                <h2>8. Pozasądowe metody rozwiązywania sporów konsumenckich</h2>
                <ul>
                    <li>Prawem właściwym dla niniejszego Regulaminu jest prawo polskie, Zasady korzystania z pozasądowych
                        sposobów rozpatrywania reklamacji i dochodzenia roszczeń możesz sprawdzić pod adresem:
                        https://uokik.gov.pl/pozasadowe_rozwiazywanie_sporow_konsumenckich.php.
                    </li>
                    <li>Przy Prezesie Urzędu Ochrony Konkurencji i Konsumentów działa także punkt kontaktowy (telefon: 22 55
                        60 333, email: kontakt.adr@uokik.gov.pl lub adres pisemny: Pl. Powstańców Warszawy 1, Warszawa.),
                        którego zadaniem jest między innymi udzielanie pomocy konsumentom w sprawach dotyczących
                        pozasądowego rozwiązywania sporów konsumenckich.
                    </li>
                    <li>Przykładowo, przysługują Ci następujące możliwości skorzystania z pozasądowych sposobów
                        rozpatrywania reklamacji i dochodzenia roszczeń:
                        <ul>
                            <li>1. Wniosek o rozstrzygnięcie sporu do stałego polubownego sądu konsumenckiego (więcej
                                informacji na stronie: http://www.spsk.wiih.org.pl/);
                            </li>
                            <li>2. Wniosek w sprawie pozasądowego rozwiązania sporu do wojewódzkiego inspektora Inspekcji
                                Handlowej (więcej informacji na stronie inspekcji handlowej);
                            </li>
                            <li>3. Pomoc powiatowego (miejskiego) rzecznika konsumentów lub organizacji społecznej, do
                                której zadań statutowych należy ochrona konsumentów (m.in. Federacja Konsumentów,
                                Stowarzyszenie Konsumentów Polskich).
                            </li>
                        </ul>
                    </li>
                    <li>Pod adresem http://ec.europa.eu/consumers/odr dostępna jest platforma internetowego systemu
                        rozstrzygania sporów pomiędzy konsumentami i przedsiębiorcami na szczeblu unijnym (platforma ODR).
                        Platforma ODR stanowi interaktywną i wielojęzyczną stronę internetową z punktem kompleksowej obsługi
                        dla konsumentów i przedsiębiorców dążących do pozasądowego rozstrzygnięcia sporu dotyczącego
                        zobowiązań umownych wynikających z internetowej umowy sprzedaży lub umowy o świadczenie usług
                        (więcej informacji na stronie samej platformy lub pod adresem internetowym Urzędu Ochrony
                        Konkurencji i Konsumentów: https://uokik.gov.pl/spory_konsumenckie_faq_platforma_odr.php).
                    </li>
                </ul>
            </section>

            <section>
                <h2>9. OCHRONA DANYCH OSOBOWYCH</h2>
                <ul>
                    <li>Klient, składając zamówienia, wyraża zgodę na przetwarzanie, podanych przez niego, danych osobowych,
                        w celu realizacji i obsługi zamówienia, przez Sprzedawcę, który jest jednocześnie administratorem
                        danych osobowych, w rozumieniu art. 7 Rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z
                        dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych
                        osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (ogólne
                        rozporządzenie o ochronie danych), Dz.Urz.UE L 119, 4 maja 2016, str. 1–88.
                    </li>
                    <li>Administratorem danych osobowych, przekazanych przez Klienta, podczas korzystania ze Sklepu, jest
                        Sprzedawca.
                    </li>
                    <li>Dane osobowe, znajdujące się w bazie danych Sprzedawcy, nie są przekazywane podmiotom, które nie
                        uczestniczą w realizacji Umowy.
                    </li>
                    <li>Klient zgodnie, z art. 15 Rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27
                        kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w
                        sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (ogólne rozporządzenie
                        o ochronie danych), Dz.Urz.UE L 119, 4 maja 2016, str. 1–88 ma prawo dostępu do swoich danych
                        osobowych, może żądać ich poprawienia lub usunięcia. Sprzedawca zapewnia każdemu Klientowi prawo
                        kontroli przetwarzanych danych osobowych.
                    </li>
                    <li>Podanie danych osobowych jest dobrowolne, jednakże brak zgody na przetwarzanie danych osobowych
                        uniemożliwia zrealizowanie zamówienia Klienta.
                    </li>
                    <li>Szczegółowe informacje w zakresie danych osobowych i ochrony prywatności zostały zawarte w zakładce
                        „Polityka prywatności" na stronie Sklepu.
                    </li>
                </ul>
            </section>

            <section>
                <h2>10. POSTANOWIENIA KOŃCOWE</h2>
                <ul>
                    <li>Regulamin określa zasady zawierania i wykonywania Umowy sprzedaży Produktów, znajdujących się na
                        stronie Sklepu.
                    </li>
                    <li>Umowa sprzedaży zawierana jest między Klientem a Sprzedawcą.</li>
                    <li>Regulamin dostępny jest dla wszystkich Klientów w wersji elektronicznej na stronie internetowej
                        Sklepu: lumestore.pl, w zakładce: „Regulamin".
                    </li>
                    <li>Aby móc korzystać z Usług Sklepu, niezbędne jest posiadanie urządzeń pozwalających na dostęp do
                        internetu oraz przeglądarki internetowej, umożliwiającej wyświetlanie stron www, jak również podanie
                        adresu e-mail, umożliwiającego przesłanie informacji, dotyczących realizacji zamówienia.
                    </li>
                    <li>Zakazuje się wszystkim osobom, w tym Klientom, zamieszczania na stronie Sklepu treści bezprawnych.
                    </li>
                    <li>W sprawach nieuregulowanych niniejszym Regulaminem stosuje się odpowiednie przepisy powszechnie
                        obowiązującego prawa.
                    </li>
                    <li>Regulamin nie wyłącza oraz nie ogranicza żadnych uprawnień Klienta, będącego Konsumentem, które
                        przysługują mu na mocy bezwzględnie obowiązujących przepisów prawa. W przypadku sprzeczności
                        pomiędzy postanowieniami Regulaminu a bezwzględnie obowiązującymi przepisami prawa, przyznającymi
                        konsumentom uprawnienia, pierwszeństwo mają przepisy prawa.
                    </li>
                    <li>Postanowienia Regulaminu mniej korzystne dla Konsumenta, niż postanowienia ustawy z dnia 30 maja
                        2014 r. o prawach konsumentów (t.j. Dz. U. z 2020 r. poz. 287, ze zm.) są nieważne, a w ich miejsce
                        stosuje się przepisy ustawy.
                    </li>
                    <li>W razie gdyby którekolwiek z postanowień niniejszego Regulaminu było lub miało stać się nieważne lub
                        bezskuteczne, ważność całego Regulaminu w pozostałej części zostaje nienaruszona. W takim przypadku
                        Strony zastąpią nieważne lub bezskuteczne postanowienie innym, które możliwie najwierniej oddaje
                        zamierzony cel gospodarczy. Odpowiednio dotyczy to także ewentualnych luk w Regulaminie.
                    </li>
                </ul>
                <hr/>
            </section>

            <div id="download-buttons-rules">
                <a className="rules-download"
                   href="https://cdn.shopify.com/s/files/1/0908/2431/1127/files/Regulamin_sklepu_lumestore.pdf?v=1755873410">
                    Pobierz regulamin w formacie PDF
                </a>
                <a className="rules-download"
                   href="https://cdn.shopify.com/s/files/1/0908/2431/1127/files/FORMULARZ_ODSTAPIENIA_OD_UMOWY_PRZEZ_KONSUMENTA_LUB_PRZEDSIEBIORCE_NA_PRAWACH_KONSUMENTA.docx?v=1792614894">
                    Pobierz formularz odstąpienia od umowy
                </a>
            </div>
        </div>
    );
}